import Protected from './Protected';

export default Protected;
